import { useFormik } from "formik";
import { useState } from "react";
import { Widget } from "@uploadcare/react-widget";
import { KTPost } from "@/kyna/lib/db";
import { toast } from "react-hot-toast";

import KNModal from "@/kyna/ui/modal/KNModal";
import InputForm from "@/kyna/forms/InputForm";
import Spinner from "@/kyna/ui/preloader/Spinner";

import { JobApplicationSchema } from "@/kyna/lib/validations/JobApplicationSchema";
import { KNThemeSuccess, KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import { JobApplicationEmail } from "@/kyna/lib/email-template/JobApplicaton";
import { validators, localeError } from "@/kyna/lib/StandardReferences";

const ApplicantsModal = ({ isOpenModal, setIsOpenModal,data }) => {
  const NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY =
    process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY;
  const [submitIsLoading, setSubmitIsLoading] = useState(false);
  const [iconType,setIconType] = useState('info');
  const [modalTitle,setModalTitle] = useState('Job Application Form');
  const formik = useFormik({
    initialValues: {
      jobs_id: data?.id,
      first_name: "",
      middle_name: "",
      last_name: "",
      contact_no: "",
      email: "",
      sex: "",
      resume: "",
    },
    validationSchema: JobApplicationSchema,
    onSubmit: async (values) => {
      setSubmitIsLoading(true)
      const mediaData = {
          path: values?.resume?.cdnUrl,
          file_name: values?.resume?.name,
          orig_name: values?.resume?.name,
          attachment_for: "Applicants - Resume",
          user_id: 0,
          is_image: values?.resume?.isImage,
          reference_id: values?.resume?.uuid,
        };
      const postData = values
      delete postData.resume
      postData.contact_no = `+63${values.contact_no}`
      const response = await KTPost('/api/applicants',postData)
      console.log("SUCCESS", response)
      if (response?.data?.success) {
        mediaData.attach_id = response?.data?.data?.id
        mediaData.applicants_id = response?.data?.data?.id
        const mediaResponse = await KTPost(
          "/api/media/applicant",
          mediaData
        );
        console.log("MediaResponse",mediaResponse)
        if (!mediaResponse?.data?.success) {
          setIconType("error");
          setModalTitle("Failed to Upload Resume");
          setSubmitIsLoading(false)
          toast.error("Failed to Upload Resume", {
            ...KNThemeError,
          })
          return;
        }
        await JobApplicationEmail(data,values)
        toast.success("Application Submitted", {
          ...KNThemeSuccess,
        })
        setSubmitIsLoading(false)
        setIsOpenModal(false)
      } else {
        setIconType("error");
        setModalTitle("Failed to Submit Application");
        setSubmitIsLoading(false)
        toast.error("Failed to Submit Application", {
          ...KNThemeError,
        })
        console.log("-----ERROR-----")
        console.log(response.data)
      }
    },
  });
  return (
    <KNModal
      isOpen={isOpenModal}
      iconType={iconType}
      title={modalTitle}
      bodyClass="max-w-4xl mt-10"
      noFooter={true}
      closeModal={() => setIsOpenModal(!isOpenModal)}
      body={
        <form onSubmit={formik.handleSubmit} className="sm:px-5 px-2">
          <div className="pt-4">
              {/* col 1 */}
              <div className="grid sm:grid-cols-3 grid-cols-1 sm:gap-4 gap-2 mb-2">
                <div className="form-group sm:!mb-1 !mb-0">
                      <label htmlFor="first_name" className='field-label mb-2'>First Name <span className="text-red-600">*</span></label>
                      <InputForm
                        type="text"
                        id="first_name"
                        name="first_name"
                        placeholder="Enter first name"
                        withFormik={true}
                        formik={formik}
                        parentClassName="w-full"
                      />
                  </div>
                  <div className="form-group sm:!mb-1 !mb-0">
                      <label htmlFor="first_name" className='field-label mb-2'>Middle Name <span className="text-red-600"> </span></label>
                      <InputForm
                        type="text"
                        id="middle_name"
                        name="middle_name"
                        placeholder="Enter middle name"
                        withFormik={true}
                        formik={formik}
                        parentClassName="w-full"
                      />
                  </div>
                  <div className="form-group sm:!mb-1 !mb-0">
                      <label htmlFor="first_name" className='field-label mb-2'>Last Name <span className="text-red-600">*</span></label>
                      <InputForm
                        type="text"
                        id="last_name"
                        name="last_name"
                        placeholder="Enter last name"
                        withFormik={true}
                        formik={formik}
                        parentClassName="w-full"
                      />
                  </div>

              </div>
            {/* col 2 */}
            <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2 mb-2">
                <div className="form-group sm:!mb-1 !mb-0">
                <label htmlFor="contact_no" className='field-label mb-2'>Contact No. <span className="text-red-600">*</span></label>
                  <div className="flex items-center">
                    <div className="form-control !w-16 mr-[10px] leading-7">
                      +63
                    </div>
                    <input
                      type="number"
                      id="contact_no"
                      name="contact_no"
                      className="form-control"
                      placeholder="9123456789"
                      onChange={(e) => {
                        formik.setFieldValue("contact_no", e.target.value);
                      }}
                      value={formik.values?.contact_no}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div className="help-block text-red-400 text-xs mt-2">
                    {formik.touched.contact_no && formik.errors.contact_no && (
                      <div>{formik.errors.contact_no}</div>
                    )}
                  </div>
                </div>
                <div className="form-group sm:!mb-1 !mb-0">
                      <label htmlFor="sex" className='field-label mb-2'>Gender <span className="text-red-600">*</span></label>
                      <select name="sex" id="sex"
                          className="form-control"
                          onChange={(e) => {
                              // handleChange(e)
                              const { name, value } = e.target;
                              console.log("sex", value)
                              formik.setFieldValue('sex', value)
                          }}
                          value={formik.values?.gender}
                          onBlur={formik.handleBlur}>
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                      </select>
                      <div className="help-block text-red-400 text-xs mt-2">
                          {
                              formik.touched.sex && formik.errors.sex && (
                                  <div>{formik.errors.sex}</div>
                              )
                          }
                      </div>
                  </div>
             </div>
             {/* col 2 */}
             <div className="grid grid-cols-1 sm:gap-4 gap-2 mb-2">
                <div className="form-group sm:!mb-1 !mb-0">
                    <label htmlFor="email" className='field-label mb-2'>Email <span className="text-red-600">*</span></label>
                    <InputForm
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Enter email address"
                        withFormik={true}
                        formik={formik}
                        parentClassName="w-full"
                      />
                </div>
                <div className="form-group sm:!mb-1 !mb-0">
                    <label htmlFor="resume" className='field-label mb-2'> Upload your Curriculum Vitae / Resume <span className="text-red-600">*</span></label>
                    <div className="col-span-12 md:col-span-8 mt-2">
                      <Widget
                        publicKey={NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY}
                        id="resume"
                        tabs="file"
                        multiple={true}
                        multipleMax={5}
                        clearable
                        validators={validators}
                        localeTranslations={localeError}
                        onChange={(file) => {
                          formik.setFieldValue("resume", file);
                        }}
                      /*  onFileSelect={(file) => {
                          console.log("File changed: ", file);
                          if (file) {
                            file.progress((info) =>
                              console.log("File progress: ", info.progress)
                            );
                            file.done((info) => {
                              console.log("File uploaded: ", info);
                              formik.setFieldValue("resume", info);
                            });
                          }
                        }} */
                      />
                      <div className="help-block text-red-400 text-xs mt-2">
                        {formik.touched.resume && formik.errors.resume && (
                          <div>{formik.errors.resume}</div>
                        )}
                      </div>
                    </div>
                </div>
             </div>
          </div>

          <div className="grid grid-cols-2 gap-3 text-right max-w-[250px] pt-3 pb-3 ml-auto mr-0">
            <button
             className="btn btn-dash-cancel"
              type="button"
              onClick={() => {
                setIsOpenModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-dash-primary"
              type={submitIsLoading ? null : "submit"}
            >
              {submitIsLoading ? (
                <Spinner isLoading={submitIsLoading} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      }
    />
  );
};

export default ApplicantsModal;
